export default {
  componentName: 'weight-leader.tsx',
  exampleImgUrl:
    'https://drive.google.com/open?id=13OSvjvUOxsCMgeqj7se_Ysr0yUS7Ludd',
  nickname: 'Weight Leader: Leaderboard, Bigbass',
  pageList: [
    'https://www.bassmaster.com/tournaments/2018-bass-pro-shops-eastern-open-1-kissimmee-chain',
    'https://cdn.api.prod.bassmasterdata.com/v1/weightleader/bigbass/pro/1217',
  ],
  renderId:
    'react-app--weight-leader--leaderboard  OR  react-app--weight-leader--bigbass',
};
